import { render, staticRenderFns } from "./TopHeader.vue?vue&type=template&id=05223f78&"
import script from "./TopHeader.vue?vue&type=script&lang=js&"
export * from "./TopHeader.vue?vue&type=script&lang=js&"
import style0 from "./TopHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports